import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './InvoicesMain'
import Show from './InvoicesShow'
import New from './InvoicesNew'
import Steps from './DetachedInvoiceSteps'

export default {
  Main,
  Show,
  New,
  Steps,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Fatura',
    entity: 'invoice',
    entityId: params.invoiceIdentifier,
  }))(Page),
}
